import React from 'react';
import PropTypes from 'prop-types';
import {
  ORDER_DETAIL_TABS,
  OPPORTUNITY_TABS,
  OPPORTUNITY_TAB,
} from './helper/orderDetailHelper';
import translate from '../../../commonComponents/translate';

const returnTabText = (t, tab, isOpportunity) => {
  if (tab === OPPORTUNITY_TAB.INFO && isOpportunity) {
    return t('opportunity.button.info');
  }
  return t(`order.button.${tab}`);
};

function TabButtons(props) {
  const { t, active, onClick, isOpportunity } = props;
  const tabs = isOpportunity ? OPPORTUNITY_TABS : ORDER_DETAIL_TABS;

  return (
    <div className="tab-buttons-wrapper">
      {tabs.map(tab => (
        <button
          className={`button-tab ${active === tab ? 'button-tab-active' : ''}`}
          key={tab}
          onClick={() => onClick(tab)}
          type="button"
        >
          {returnTabText(t, tab, isOpportunity)}
        </button>
      ))}
    </div>
  );
}

TabButtons.propTypes = {
  t: PropTypes.func.isRequired,
  active: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isOpportunity: PropTypes.bool,
};

TabButtons.defaultProps = {
  isOpportunity: false,
};

export default translate(TabButtons);
